import React from 'react';

const Loading = () => {
  return (
    <div className="loading_wrap">
      <div className="loading">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Loading;
